import { z } from "zod";
/** Bounded inspection copy; large values remain in their original evidence store. */
export const workflowTraceValueSchema = z.object({
    evidenceId: z.string().regex(/^[0-9a-f]{64}$/u).optional(),
    value: z.json(), bytes: z.number().int().nonnegative(), omitted: z.boolean(),
}).strict().refine(v => v.omitted ? v.value === null : new TextEncoder().encode(JSON.stringify(v.value)).length <= 32768, "Trace values must be bounded or explicitly omitted");
export const workflowNodeTraceSchema = z.object({
    nodeId: z.string().regex(/^[A-Za-z_][A-Za-z0-9_]{0,63}$/u),
    status: z.enum(["running", "succeeded", "failed"]),
    startedAt: z.number().int().positive(), completedAt: z.number().int().positive().nullable(),
    input: workflowTraceValueSchema, output: workflowTraceValueSchema.nullable(),
    error: z.string().max(4000).nullable(),
    judgmentSkipped: z.boolean(),
    skippedEffects: z.array(z.string().min(1).max(64)).max(64),
}).strict().superRefine((trace, ctx) => {
    if ((trace.status === "running") !== (trace.completedAt === null) ||
        (trace.completedAt !== null && trace.completedAt < trace.startedAt) ||
        (trace.status === "failed" && !trace.error))
        ctx.addIssue({ code: "custom", message: "Invalid trace lifecycle" });
});
export function workflowTraceValue(value) {
    const json = JSON.stringify(value ?? null);
    const bytes = new TextEncoder().encode(json).length;
    return { value: bytes > 32768 ? null : JSON.parse(json), bytes, omitted: bytes > 32768 };
}
